import * as React from "react";
import { useTranslation } from "react-i18next";
import QueryHelper from "components/common/QueryHelper";
const EXAMPLE_QUERY = "title:security";
const SharedEntitiesQueryHelper = () => {
  const { t } = useTranslation("users");
  const queryExample = /* @__PURE__ */ React.createElement("p", null, t("permissions.shared_entities.query_example"), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("kbd", null, EXAMPLE_QUERY), /* @__PURE__ */ React.createElement("br", null));
  return /* @__PURE__ */ React.createElement(QueryHelper, { entityName: "shared entity", commonFields: ["title"], example: queryExample });
};
export default SharedEntitiesQueryHelper;
